/*
 * Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Component, Input } from "@angular/core";

@Component({
    selector: "bci-list-skeleton",
    templateUrl: "./list-skeleton.component.html",
    styleUrls: ["./list-skeleton.component.scss"],
    standalone: false
})
export class ListSkeletonComponent {
  @Input() elements = 10;

  constructor() {}

  elementArray() {
    return Array(this.elements);
  }
}
